import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './new_styles.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize AOS
if (typeof window !== 'undefined') {
  const AOS = require('aos');
  AOS.init({
    duration: 1000,
    once: true,
    offset: 100
  });
}

